<template>
    <div :class="{
        'update-content position-absolute': true,
        'update-content-mobile' : $detect == 'mobile'

            }">
        <div class="content">
            <div class="card-dashboard">
                <div class="py-10px px-3 border-bottom border-primary title-popup-mobile">
                    <span class="mb-0">Chỉnh sửa nội dung</span>
                    <div class="close" role="button">
                        <i :class="{
                            'icon': true,
                            'ion-md-close': $detect == 'web',
                            'ion-ios-arrow-back': $detect == 'mobile',
                        }" @click="updateCheck = 0"></i>
                    </div>
                </div>
                <div class="content-card p-3">
                    <editor :content.sync="form.description"/>
                    <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.description">
                        {{error.description}}
                    </div>
                </div>
                <div class="btn-confirm text-center pb-3">
                    <button class="btn btn btn-secondary btn-sm mr-2" @click="updateCheck = 0" v-if="$detect == 'web'">Huỷ</button>
                    <button class="btn btn-primary btn-sm ml-2" @click="submit()" :disabled="loading">Cập nhật</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['active', 'data'],
    components: {
        editor: () => import('@/components/editor/index'),
    },
    data(){
        return {
            form: {},
            updateCheck: 0,
            loading: false,
            id: this.$route.params.id,
        }
    },
    computed:{
        error(){
            return this.$store.state.errorPutRv;
        }
    },
    watch: {
        active(val){
            this.updateCheck = val;
        },
        updateCheck(val){
            this.$emit('update:active', val);
        },
        data: {
            handler(val){
                this.form = {
                    description: val.description,
                    status: val.status,
                }
            },
            deep: true,
        }
    },
    created() {
        this.form = {
            description: this.data.description,
            status: this.data.status,
        }
    },
    methods: {
        async submit(){
            this.loading = false;
            await apiPut(`/v2/profile/product/${this.id}`, {
                description: this.form.description,
                execute  :    'update'
            }).then(res => {
                if(res.success == 1){
                    this.$message({
                        message: 'Thay đổi mô tả chi tiết thành công',
                        type: 'success',
                        center: true,
                    });
                    this.form.status = res.data.status;
                    this.emitData();
                    this.$store.commit('dataErrorPutRv', {})
                }else{
                    this.$store.commit('dataErrorPutRv', res.message.error);
                }
            }).catch(err => {
                if(err.status == 422){
                    this.$store.commit('dataErrorPutRv', err.data);
                }
            })
            this.loading = false;
        },
        emitData(){
            this.$emit('dataEmit', this.form);
            this.updateCheck = 0;
        },
    }
}
</script>

<style lang="scss">
#content-description{
    ul{
        list-style: none;
    }
}
    .update-content {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(240, 245, 249, 0.8);
        input {
            &:focus {
                outline: none !important;
            }
        }
        .btn-confirm {
            button {
                width: 120px;
            }
        }
    }
    .update-content-mobile {
        position: fixed !important;
        height: 100vh !important;
        .content {
            .card-dashboard {
                height: 100vh;
                overflow-y: auto;
                border-radius: 0 !important;
                .content-card {
                    padding: 0 !important;
                }
            }
        }
        .title-popup-mobile {
            background: #007bff;
            color: #fff;
            text-align: center;
            .close {
                float: left;
                i {
                    color: rgba(255, 255, 255, 1.0);
                    padding-right: 20px;
                }
            }
            span {
                margin-left: -29px;
            }
        }
        .btn-confirm {
            margin-top: 16px;
            button {
                margin-left: 0 !important;
                height: 40px;
                width: 200px !important;
            }
        }
        .edit-img {
            left: 0 !important;
        }
        .tinymce > .mce-container {
            width: unset !important;
        }
        .dialog-edit {
            .ldc-dialog-content {
                width: 100% !important;
                height: 100vh !important;
                overflow: auto;
                .my-img {
                    height: unset !important;
                }
            }
            .title-dialog {
                position: fixed;
                width: 100%;
                top: 0 !important;
                left: 0;
                z-index: 1;
                background: #007bff;
                color: #fff !important;
            }
            .main-dialog {
                margin-top: 45px;
                margin-bottom: 61px;
            }
            .close-dialog {
                color: #fff;
                z-index: 1;
                position: fixed !important;
            }
            .footer-dialog {
                position: fixed;
                bottom: 0 !important;
                width: 100%;
                left: 0 !important;
                background: #fff;
                button {
                    height: 40px;
                    width: 200px !important;
                }
            }
            .upload-img {
                width: 33.33333333333333% !important;
                height: 100px !important;
                padding: 16px 8 0 !important;
                .btn-upload {
                    width: 100% !important;
                    height: 100% !important;
                    padding: 5px 0 !important;
                }
            }
            .img {
                width: 33.33333333333333% !important;
                padding: 16px 8 0 !important;
                height: 100px !important;
                img {
                    width: 100% !important;
                    height: 100% !important;
                }
                .delete-img {
                    display: block !important;
                    top: 16px !important;
                    right: 8px !important;
                }
            }
        }
    }
</style>
